export const environment = {
  BASE_URL: "https://document-search-api-qa.sosin.gov",
  production: false,
  firebase: {
    apiKey: "AIzaSyDZ90aUmpqjuC-V6plbrMmTNY8fJczuvUY",
    authDomain: "indiana-sos-qa.firebaseapp.com",
    projectId: "indiana-sos-qa",
    storageBucket: "indiana-sos-qa.firebasestorage.app",
    messagingSenderId: "680484163543",
    appId: "1:680484163543:web:11f6dc7b45268849710592",
  },
};
